import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-lotus-petal bg-background px-6 py-10 lg:px-8">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 md:flex-row">
        <div className="text-center md:text-left">
          <span className="font-serif text-xl text-lotus-ink font-medium">
            Lotus Prana
          </span>
          <p className="mt-1 text-[10px] uppercase tracking-widest text-lotus-ink/50 font-medium">
            By Preeti Biswas — Founder & CEO
          </p>
        </div>

        <p className="text-[10px] uppercase tracking-widest text-lotus-ink/50 font-medium text-center md:text-right">
          © {currentYear} Lotus Prana. All Rights Reserved. Designed by <a className="text-lotus-ink/50 hover:text-lotus-deep transition-colors" href="https://wa.me/919773197533" target="_blank" rel="noopener noreferrer">TechTack360</a>.
        </p>
      </div>
    </footer>
  );
};

export default Footer;



